<template>
  <div class="overlay info">
    <div v-html="info.cv" />
    <div v-html="info.text" />
  </div>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "info",
  metaInfo() {
    return {
      title: "– Info",
      meta: [
        {
          description: this.info.text
        }
      ]
    };
  },
  created() {
    this.$store.dispatch("loadInfo");
  },
  computed: mapState(["info"])
};
</script>

<style lang="scss">
.info {
  > div {
    margin-bottom: var(--lh);
  }
}
</style>
